import { render, staticRenderFns } from "./LinksSG.vue?vue&type=template&id=c9b5aaf6&scoped=true"
import script from "./LinksSG.vue?vue&type=script&lang=js"
export * from "./LinksSG.vue?vue&type=script&lang=js"
import style0 from "./LinksSG.vue?vue&type=style&index=0&id=c9b5aaf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b5aaf6",
  null
  
)

export default component.exports